import { render, staticRenderFns } from "./PrintPosFaR2NotVisible.vue?vue&type=template&id=88a220b8&scoped=true"
import script from "./PrintPosFaR2NotVisible.vue?vue&type=script&lang=js"
export * from "./PrintPosFaR2NotVisible.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFaR2NotVisible.vue?vue&type=style&index=0&id=88a220b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a220b8",
  null
  
)

export default component.exports